import { useState } from "react";

import type { AttributeReviewFieldDecisionInput } from "@/graphql/generated";
import type { AttributeReviewMappingRow } from "@/hooks/useAttributeReview.types";
import {
  pathDecision,
  type PathAction,
} from "@/lib/attributeReview/pathDecision";

export type DecideRows = (
  decisions: AttributeReviewFieldDecisionInput[],
) => Promise<boolean>;

export function useReviewPathActions(
  row: AttributeReviewMappingRow,
  decideRows: DecideRows,
) {
  const [busy, setBusy] = useState<PathAction | null>(null);
  const run = (action: PathAction) => async (copyOf?: string) => {
    if (busy) return false;
    setBusy(action);
    try {
      return await decideRows([pathDecision(action, row, copyOf)]);
    } finally {
      setBusy(null);
    }
  };
  return {
    unlink: run("unlink"),
    showToSeller: run("showToSeller"),
    copy: run("copy"),
    busy,
  };
}
